import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-14 sm:py-24 px-4 relative" data-id="element-46">
      <div className="max-w-4xl mx-auto" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-brand-dark to-[#1a1a24] border-2 border-brand-gold/30 rounded-2xl p-5 sm:p-12 text-center relative overflow-hidden shadow-[0_0_50px_rgba(212,168,83,0.1)]" data-id="element-48">
          {/* Decorative background elements */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-gold to-transparent opacity-50" data-id="element-49" />
          <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-gold to-transparent opacity-50" data-id="element-50" />

          <div className="flex justify-center mb-5 sm:mb-8 relative z-10" data-id="element-51">
            <div className="bg-brand-gold/10 p-3 sm:p-4 rounded-full border border-brand-gold/30" data-id="element-52">
              <Shield className="w-12 h-12 sm:w-16 sm:h-16 text-brand-gold" data-id="element-53" />
            </div>
          </div>

          <h2 className="text-2xl sm:text-4xl font-bold text-brand-gold mb-4 sm:mb-6 tracking-wide" data-id="element-54">
            THE "RISK-FREE READING" 7-DAY GUARANTEE
          </h2>

          <p className="text-base sm:text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-55">
            Download the Ebook. Read the Prologue. If you feel this digital
            content doesn't equip you with the tools needed to defend your
            values, send us an email. We'll refund your $17 and{' '}
            <strong className="text-white" data-id="element-56">
              you can keep the PDF file as a gesture of goodwill.
            </strong>{' '}
            That's how confident we are in this legacy.
          </p>
        </motion.div>
      </div>
    </section>;
}